/**
 * Event模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const event = {
  //分页
  page(params) {
    return $http.post(`${global.API_URL}/sme/resourceEvent/page`, params);
  },
  getEventTypes(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceEvent/getEventTypes`, param);
  },
  getResourceTypes(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceEvent/getResourceTypes`, param);
  },
  // 下载Excel文件
  export(params) {
    return $http.post(`${global.API_URL}/sme/resourceEvent/exportEvents`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  }
}

export default event;



// WEBPACK FOOTER //
// ./src/api/event.js